import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { isEmpty } from '@/utils/misc';
import { computed } from 'vue';
import { TranslateResult } from 'vue-i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ClickMenu',
  props: {
    ids: null,
    names: null,
    icon: { default: '' },
    iconPack: { default: 'mdi' },
    title: { default: '' },
    value: { default: () => [] },
    type: { default: 'multiple' },
    position: { default: 'is-bottom-left' },
    size: { default: 'is-medium' },
    itemIcons: { default: () => [] },
    itemIconPack: { default: 'mdi' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: Array<number | string> | number | string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { ids: Array<number | string>, names: string[], icon: string, iconPack: string, title: string | TranslateResult, value: Array<number | string> | string | number | null, type: 'single' | 'multiple', position: string, size: string, itemIcons: string[], itemIconPack: string };

const ALL_SWITCH_INDEX = -1;





const { t } = useI18n();

function change(index: number, id: string | number, isSwitchedOn: boolean) {
  if (!Array.isArray(props.value)) {
    // This will never apply as value will always be an array for multiple selection
    return;
  }
  if (index === ALL_SWITCH_INDEX) {
    emit('input', isSwitchedOn ? [...props.ids] : []);
  } else if (isSwitchedOn) {
    emit('input', [...props.value, id]);
  } else {
    emit(
      'input',
      props.value.filter((x: number | string) => x !== id),
    );
  }
}

const allChecked = computed(
  () => Array.isArray(props.value) && props.value.length === props.ids.length,
);

return { __sfc: true,ALL_SWITCH_INDEX, props, emit, t, change, allChecked, isEmpty }
}

})